import { render, staticRenderFns } from "./vipRouter.vue?vue&type=template&id=86ce3ddc"
import script from "./vipRouter.vue?vue&type=script&lang=js"
export * from "./vipRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports